import { render, staticRenderFns } from "./ContestDocumentsView.vue?vue&type=template&id=483e69a4&scoped=true&"
import script from "./ContestDocumentsView.vue?vue&type=script&lang=js&"
export * from "./ContestDocumentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483e69a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
